export const IMAGE_MIME_TYPE_PREFIX = 'image/';

export const MMS_MAX_IMAGE_SIZE = {
  errorMessage:
    'File size must be less than 1 MB (we recommend less than 500 KB for optimal sizing & resolution)',
  label: '1 MB',
  value: 1_000_000,
};

export const RCS_CARD_MAX_IMAGE_SIZE = {
  errorMessage: 'File size must be less than 100 MB',
  label: '100 MB',
  value: 100_000_000,
};

export const RCS_CAROUSEL_CARD_MAX_IMAGE_SIZE = {
  errorMessage: 'File size must be less than 10 MB',
  label: '10 MB',
  value: 10_000_000,
};

export const RCS_CARD_FALLBACK_MAX_IMAGE_SIZE = {
  errorMessage:
    'RCS Image is too large for the MMS Fallback. Select a new image (<1 MB) in Fallback settings.',
  label: '1 MB',
  value: 1_000_000,
};

export const RCS_CAROUSEL_FALLBACK_MAX_IMAGE_SIZE = {
  errorMessage:
    'RCS Image in Card 1 is too large for the Fallback. Select a new image (<1 MB) in Fallback settings.',
  label: '1 MB',
  value: 1_000_000,
};

export const MMS_COMPRESSED_IMAGE_MESSAGE = `Images may be compressed to fit file size limit.`;
export const MMS_IMAGE_CARRIER_SUPPORT_MESSAGE = `Images and GIFs (MMS) aren't supported by all carriers or countries. Plain text (SMS) without media may be sent instead.`;
